import { sortArray, isEditorRole, isViewerRole, isDistributedInstance } from '@/utils'
import { mapGetters, mapState } from 'vuex'
import { createQuickAndDetailedSnapshots } from '@/mixins/createSnapshot'
import { snapshotEnums } from '@/mixins/snapshot'

export const breadcrumbs = {
    mixins: [snapshotEnums, createQuickAndDetailedSnapshots],
    methods: {
        sortArray() {
            return sortArray
        },
        showInstanceOpenSnackBar(instanceName) {
            this.$store.dispatch('showSnackBar', {
                snackBarText: `Moved to instance: ${instanceName}`,
                snackBarTimeout: 5000,
                snackBarIcon: 'check_circle'
            })
        },
        goToMaster() {
            this.openInstance('master', this.masterInstance.iid, this.roleTypes.INSTANCE_EDITOR)
        },
        fetchDistributedInstanceSnapshots(iid, routeName = 'snapshot-overview', extraParams = {}) {
            this.$axios
                .get(`instances/${iid}/snapshots`)
                .then(response => {
                    if (response.data && response.data.length < 2) {
                        const delay = 2000
                        this.$store.dispatch('showSnackBar', {
                            snackBarText: 'Distributed has no snapshots, resetting to master instance.',
                            snackBarTimeout: delay,
                            snackBarIcon: 'info'
                        })
                        setTimeout(() => {
                            this.goToMaster()
                        }, delay)
                    } else if (response.data && response.data.length > 1) {
                        const sortedSnapshots = sortArray(response.data, 'snid', 'descending', false)
                        const nonDevelopmentSnapshots = sortedSnapshots.filter(snapshot => snapshot.long_id !== 'Current State')
                        const mostRecentSnapshot = nonDevelopmentSnapshots[0]
                        this.$router.push({
                            name: routeName,
                            params: {
                                oid: this.$route.params.oid,
                                sid: this.$route.params.sid,
                                iid: mostRecentSnapshot.iid,
                                snid: mostRecentSnapshot.snid,
                                ...extraParams
                            }
                        })
                        this.showInstanceOpenSnackBar(mostRecentSnapshot.long_id)
                    }
                })
                .catch(error => {
                    console.log(error)
                    this.$store.dispatch('showSnackBar', {
                        snackBarText: 'Failed to fetch snapshots of distributed',
                        snackBarTimeout: 5000,
                        snackBarIcon: 'error'
                    })
                })
        },
        async openInstance(instanceName, iid, role) {
            // instanceName => NO NEED, less input the better!
            await this.$store.dispatch('instanceStore/fetchSnapshots', iid)
            if (isEditorRole(role) && !isDistributedInstance(instanceName)) {
                const sortedInstanceSnapshots = sortArray(this.instanceSnapshots, 'snid', 'ascending', false)
                if (sortedInstanceSnapshots.length) {
                    this.$router.push({
                        name: 'snapshot-overview',
                        params: { oid: this.$route.params.oid, sid: this.$route.params.sid, iid, snid: sortedInstanceSnapshots[0].snid }
                    })
                    this.showInstanceOpenSnackBar(instanceName)
                }
            } else if (isDistributedInstance(instanceName)) {
                this.fetchDistributedInstanceSnapshots(iid)
            } else if (isViewerRole(role)) {
                const sortedInstanceSnapshots = sortArray(this.instanceSnapshots, 'snid', 'descending', false)
                this.$router.push({
                    name: 'snapshot-overview',
                    params: { oid: this.$route.params.oid, sid: this.$route.params.sid, iid, snid: sortedInstanceSnapshots[0].snid }
                })
                this.showInstanceOpenSnackBar(instanceName)
            }
        }
    },
    computed: {
        ...mapGetters('instanceStore', ['isInstanceEditor', 'isDistributedInstance']),
        ...mapState('instanceStore', ['instanceSnapshots']),
        ...mapState('spaceStore', ['masterInstance'])
    }
}
